import { authFetch } from "./base";
export const createSegment = async (eventId, settings) => {
    const response = await authFetch(`api/createSegment/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ eventId, ...settings }),
    });
    if (!response.ok) {
        let detail = response.statusText;
        try {
            const body = await response.json();
            if (body.message) {
                detail = body.message;
            }
        }
        catch {
            // empty or non-JSON body (e.g. 502 from proxy)
        }
        throw new Error(`Failed to create segment: ${detail}`);
    }
    const json = await response.json();
    return json.data;
};
export const startSession = async (eventId, segmentId) => {
    const response = await authFetch(`api/events/${eventId}/segments/${segmentId}/startSession`, {
        method: 'POST',
    });
    if (!response.ok) {
        let detail = response.statusText;
        try {
            const text = await response.text();
            if (text) {
                detail = text;
            }
        }
        catch {
            // ignore
        }
        throw new Error(`Failed to start session: ${detail}`);
    }
};
export const forceStopSegment = async (eventId, segmentId) => {
    const response = await authFetch(`api/events/${eventId}/segments/${segmentId}/forceStop`, {
        method: 'POST',
    });
    if (!response.ok) {
        let detail = response.statusText;
        try {
            const body = await response.json();
            if (body.message) {
                detail = body.message;
            }
        }
        catch {
            // empty or non-JSON body (e.g. 502 from proxy)
        }
        throw new Error(`Failed to force stop segment: ${detail}`);
    }
};
export const fetchTranscription = async (eventId, segmentId, lang) => {
    const response = await authFetch(`api/events/${eventId}/segments/${segmentId}/transcriptions/${lang}`);
    if (!response.ok) {
        return null;
    }
    return response.text();
};
export const fetchSegmentClients = async (eventId, segmentId) => {
    const response = await authFetch(`api/events/${eventId}/segments/${segmentId}/clients`);
    if (!response.ok) {
        return null;
    }
    const json = await response.json();
    return json.data;
};
export const fetchClientLatencies = async (eventId, segmentId, clientId) => {
    const response = await authFetch(`api/events/${eventId}/segments/${segmentId}/latencies/${clientId}`);
    if (!response.ok) {
        return null;
    }
    return response.blob();
};
